// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var View__Jsx3 = require("../../helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");

function Image__Jsx3(props) {
  return React.createElement(View__Jsx3.make, {
              width: props.width,
              height: props.height,
              flexShrink: 0,
              position: "relative",
              children: Caml_option.some(React.createElement("img", {
                        className: Curry._1(Css.style, {
                              hd: Css.flexShrink(0),
                              tl: {
                                hd: Css.display("block"),
                                tl: {
                                  hd: Css.objectFit("cover"),
                                  tl: {
                                    hd: Css.width({
                                          NAME: "percent",
                                          VAL: 100
                                        }),
                                    tl: {
                                      hd: Css.height({
                                            NAME: "percent",
                                            VAL: 100
                                          }),
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }
                            }),
                        alt: props.alt,
                        src: props.src
                      }))
            });
}

var View;

var make = Image__Jsx3;

exports.View = View;
exports.make = make;
/* Css Not a pure module */
